import { createSlice } from "@reduxjs/toolkit";
import { STATUS } from "../../constants/general";

const initialState = {
  wheels: [],
  selectedBundle: null,
};

const aiWheelsSlice = createSlice({
  name: "aiWheels",
  initialState,
  reducers: {
    addAiWheel: (state, action) => {
      state.wheels.push({
        id: action.payload.id,
        status: STATUS.IN_PROGRESS,
        prompt: action.payload.prompt,
        body: action.payload.body || "Generating AI Wheel...",
        ...action.payload,
      });
    },
    updateAiWheel: (state, action) => {
      const wheelIndex = state.wheels.findIndex(
        (w) => w.id === action.payload.id
      );
      if (wheelIndex !== -1) {
        // Replace the entire wheel object with new data while preserving fields not included in payload
        state.wheels[wheelIndex] = {
          ...state.wheels[wheelIndex],
          ...action.payload,
        };
      }
    },
    removeAiWheel: (state, action) => {
      state.wheels = state.wheels.filter(
        (wheel) => wheel.id !== action.payload.id
      );
    },
    clearAllAiWheels: (state, action) => {
      state.wheels = [];
    },
    setSelectedBundle: (state, action) => {
      state.selectedBundle = action.payload;
    },
    clearSelectedBundle: (state) => {
      state.selectedBundle = null;
    },
  },
});

export const { addAiWheel, removeAiWheel, updateAiWheel, clearAllAiWheels, setSelectedBundle, clearSelectedBundle } =
  aiWheelsSlice.actions;
export default aiWheelsSlice.reducer;
